const storagePrefix = import.meta.env.VITE_STORAGE_PREFIX;

const storage = {
    getCurrentErrors: () => {
        const errors = JSON.parse(window.localStorage.getItem(`${storagePrefix}errors`) as string) as string;
        return parseInt(errors, 10) || 0;
    },
    setCurrentErrors: (errors: number) => {
        window.localStorage.setItem(`${storagePrefix}errors`, JSON.stringify(errors));
    },
    getCurrentErrorsChecked: () => {
        const errorsChecked = JSON.parse(
            window.localStorage.getItem(`${storagePrefix}errorsChecked`) as string,
        ) as boolean;
        return errorsChecked;
    },
    setCurrentErrorsChecked: (errorsChecked: boolean) => {
        window.localStorage.setItem(`${storagePrefix}errorsChecked`, JSON.stringify(errorsChecked));
    },
    setLanguage: (language: string) => {
        window.localStorage.setItem(`${storagePrefix}language`, JSON.stringify(language));
    },
    getLanguage: () => {
        const language = JSON.parse(window.localStorage.getItem(`${storagePrefix}language`) as string) as string;
        return language || 'en-US';
    },
    getToken: () => {
        const refresh = JSON.parse(window.localStorage.getItem(`${storagePrefix}refresh`) as string) as string | null;
        const access = JSON.parse(window.localStorage.getItem(`${storagePrefix}access`) as string) as string | null;
        return { refresh, access };
    },
    // We should probably store the refresh token elsewhere
    setToken: ({ refresh, access }: { refresh?: string; access?: string }) => {
        if (refresh) window.localStorage.setItem(`${storagePrefix}refresh`, JSON.stringify(refresh));
        if (access) window.localStorage.setItem(`${storagePrefix}access`, JSON.stringify(access));
    },
    clearToken: () => {
        window.localStorage.removeItem(`${storagePrefix}refresh`);
        window.localStorage.removeItem(`${storagePrefix}access`);
    },
    clear: () => {
        window.localStorage.clear();
    },
};

type StoredTableState = {
    pageIndex: number;
    pageSize: number;
};

const tableStorage = {
    getTableState: (key: string) => {
        const tableState = JSON.parse(
            window.localStorage.getItem(`${storagePrefix}${key}`) as string,
        ) as StoredTableState;
        return tableState;
    },
    setTableState: (key: string, state: Partial<StoredTableState>) => {
        window.localStorage.setItem(`${storagePrefix}${key}`, JSON.stringify(state));
    },
    updateTableState: (key: string, state: Partial<StoredTableState>) => {
        const tableState = JSON.parse(
            window.localStorage.getItem(`${storagePrefix}${key}`) as string,
        ) as StoredTableState;
        window.localStorage.setItem(`${storagePrefix}${key}`, JSON.stringify({ ...tableState, ...state }));
    },
};

export { storage, tableStorage };
